import i18n from 'i18next';
import React, { useEffect } from 'react';
import { signOut } from 'aws-amplify/auth';
import { authConfig } from '../../amplify-config';
import { Col, Container, Row, Spinner } from 'react-bootstrap';

const AuthLogout = () => {
	useEffect(() => {
		console.warn('Logout page loaded');
		async function logout() {
			try {
				await signOut();
				window.location.href =
					`https://${authConfig.domain}/logout?client_id=${authConfig.clientId}` +
					`&logout_uri=${encodeURIComponent(authConfig.redirectSignOutUri)}`;
			} catch (err) {
				console.error('Logout error:', err);
			}
		}

		logout();
	}, []);

	return (
		<Container fluid className="vh-100 d-flex justify-content-center align-items-center">
			<Row>
				<Col className="text-center">
					<Spinner animation="border" role="status" variant="primary" />
					<p className="mt-3">Processing logout...</p>
				</Col>
			</Row>
		</Container>
	);
};

export default {
	title: () => i18n.t('foedus-logout'),
	main: AuthLogout
};
